import { createSelector } from '@reduxjs/toolkit';
import { EditIcon } from 'evergreen-ui';
import { getToasterError } from '../utils';
import { dcpcApi } from './dcpcApi';

const NOTIFICATION_TYPES_TAG = 'NotificationTypes';

dcpcApi.enhanceEndpoints({ addTagTypes: [NOTIFICATION_TYPES_TAG] });
const notificationTypesApi = dcpcApi.injectEndpoints({
  endpoints: (builder) => ({
    getNotificationTypes: builder.query({
      query: () => 'notification-types',
      providesTags: [NOTIFICATION_TYPES_TAG],
      // todo: убрать тостер, когда будет middleware на обработку ошибок
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          getToasterError(err, 'типов уведомлений', 'notification-types');
        }
      },
    }),
    getNotifyType: builder.query({
      query: (code) => `notification-types/${code}`,
      providesTags: [NOTIFICATION_TYPES_TAG],
      // todo: убрать тостер, когда будет middleware на обработку ошибок
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          getToasterError(err, 'типа уведомления', 'notification-type');
        }
      },
    }),
    updateNotifyType: builder.mutation({
      query: ({ code, body }) => ({
        url: `notification-types/${code || ''}`,
        method: code ? 'PUT' : 'POST',
        body,
      }),
      invalidatesTags: [NOTIFICATION_TYPES_TAG],
    }),

    getSystemCodesNotifyTypes: builder.query(({
      query: () => 'notification-types/system-codes',
      providesTags: [NOTIFICATION_TYPES_TAG],
      // todo: убрать тостер, когда будет middleware на обработку ошибок
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          getToasterError(err, 'системных кодов типов уведомлений', 'nt/system-codes');
        }
      },
    })),
  }),
});

export const {
  useGetNotificationTypesQuery,
  useGetNotifyTypeQuery,
  useGetSystemCodesNotifyTypesQuery,

  useUpdateNotifyTypeMutation,
} = notificationTypesApi;

export const notificationTypesSelect = (state) => notificationTypesApi.endpoints.getNotificationTypes.select()(state);
export const notificationTypesSelector = (state) => notificationTypesSelect(state).data || [];

export const systemCodesSelect = (state) => notificationTypesApi.endpoints.getSystemCodesNotifyTypes.select()(state);
export const systemCodesNotifyTypesSelector = (state) => systemCodesSelect(state).data || [];

export const filterNotificationTypesBySearchTextSelector = createSelector(
  notificationTypesSelector,
  (_, searchText) => searchText,
  (notifyType, searchText) => ({
    columns: [
      {
        label: 'Код',
      },
      {
        label: 'Наименование',
      },
      {
        label: 'Описание',
      },

    ],
    rows: notifyType.reduce((acc, cur) => {
      const {
        code, name, description,
      } = cur;
      const row = [code, name, description].map((v) => v || '');
      if (row.filter((v, idx) => idx !== 0 && v !== null && v.toUpperCase().includes(searchText.toUpperCase())).length > 0) {
        acc.push(row);
      }
      return acc;
    }, []),
    rowButtons: [
      {
        label: 'Редактировать',
        to: (code) => `${code}`,
        icon: EditIcon,
      },
    ],
    createLink: {
      label: 'Создать тип уведомлений',
    },
  }),
);

export const notificationTypesBySearchTextSelector = (searchText) => (state) => filterNotificationTypesBySearchTextSelector(state, searchText);
